import { defineMessages } from 'react-intl-next';
export var selectionToolbarMessages = defineMessages({
  toolbarAppears: {
    id: 'fabric.editor.toolbarAppears',
    defaultMessage: 'Toolbar appears',
    description: 'Label for toolbar position options'
  },
  toolbarPositionInline: {
    id: 'fabric.editor.toolbarPositionInline',
    defaultMessage: 'In-line with text',
    description: 'Label for in-line toolbar position option'
  },
  toolbarPositionFixedAtTop: {
    id: 'fabric.editor.toolbarPositionFixedAtTop',
    defaultMessage: 'Fixed at top',
    description: 'Label for fixed at top toolbar position option'
  }
});